<template lang="pug">
  #app
    transition(name='move' mode='out-in')
      router-view
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="less">
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    outline: none !important;
    user-select: none;
  }
  html, body {
    margin: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    background-color: #18a4ff;
    font-family: -apple-system, BlinkMacSystemFont,
      "Segoe UI", Roboto, Helvetica, Arial, sans-serif,
      "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  .move-enter-active,
  .move-leave-active {
    transition: .3s all;
  }
  .move-enter,
  .move-leave-to {
    opacity: 0;
    transform: translateX(20px);
  }
  .move-enter-to,
  .move-leave {
    opacity: 1;
    transform: translateX(0);
  }
  #app {
    height: 100%;
    padding: 24px;
    overflow: hidden;
  }
  .std-layout {
    display: flex;
    flex-direction: column;
    height: 100%;
    .content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .std-number-input {
    width: 100%;
    height: 46px;
    .el-input, .el-input__inner {
      height: 100%;
    }
    .el-input__inner {
      text-align: right;
      font-size: 32px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: #18a4ff;
    }
    .el-input-number__increase,
    .el-input-number__decrease {
      line-height: 22px !important;
    }
  }
  @media screen and (min-width: 480px) {
    html, body {
      width: 100%;
      height: 100%;
      background-color: inherit;
    }
    body {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #FCFCFC;
    }
    #app {
      width: 420px;
      height: 640px;
      background-color: #17a4ff;
      border-radius: 12px;
      border: 2px solid #EEE;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue